var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "540"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "tit tit--xs"
  }, [_vm._v("반품요청")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "반품사유",
      "placeholder": " ",
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: _vm.reason,
      callback: function callback($$v) {
        _vm.reason = $$v;
      },
      expression: "reason"
    }
  }), _c('v-textarea', {
    staticClass: "mt-4",
    attrs: {
      "label": "반품 요구사항 & 상세내용",
      "placeholder": " ",
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: _vm.demand,
      callback: function callback($$v) {
        _vm.demand = $$v;
      },
      expression: "demand"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "grey"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.input
    }
  }, [_vm._v("확인")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }